// @ts-nocheck
/*
 *  This file file-upload.service.ts is part of HROne Inbox. The intelectual property owned by Uneecops Workplace Solution PVT. LTD.
 *  CopyrightYear: 2022
 *  (C) 2015-2022. All Right reserved. Uneecops Workplace Solution PVT. LTD.
 *
 */

import { Injectable, inject } from '@angular/core';
import { HttpService } from './http-service';
import { SharedService } from './shared.service';
import { SnackbarAlertService } from './snackbar-alert.service';
import { TFileDownloadVirtualUrl } from '../models/common.models';
import { Observable, throwError } from 'rxjs';

export interface FileDataModel {
    fileName: string;
    fileDbName: string;
    filePath: string;
}

export type FileUploadWithFolderIdResponse = Pick<FileDataModel, 'fileName' | 'fileDbName'> & {
    folderName: string;
    resizedImageDbFileName?: string;
    virtualPath?: string
};

export type FileUploadWithFolderIdPayload = { File: File | null, FolderId: number, FileExtensionsAllow: number }

export type UploadFileApiType = 'file' | 'userFile' | 'image' | 'compressImage';

export interface UploadFileModel {
    apiType?: UploadFileApiType;
    File: File;
    FolderName?: string;  // if apiType == file || apiType ==  image || apiType ==  compressImage
    FileExtensionsAllow?: number;   // if apiType == file || apiType ==  userFile
    EmployeeCode?: string;    // if apiType == userFile
    ModuleName?: string;       // if apiType == userFile
    ProcessName?: string;     // if apiType == userFile
    CompressRatio?: number;   // if  apiType ==  compressImage
    FileMaxSize?: string;
    FolderId?: number;
    isResize?: boolean;
}

export const fileUrls = {
    imageResizeUpload: '/api/core/file/UploadResizeImage',
    externalfileVirtualUrl: '/api/external/access/FileVirtualUrl?fileDbName=',
    externalfileUploadUser: '/api/external/access/UploadUserFile',
    fileUploadUrl: '/api/File/UploadUserFile'
};

@Injectable()
export class FileUploadService {
    fileSize = '5MB';

    fileValidation = {
        0: {                  // for resize image upload
            size: 5242880,
            types: ['png', 'jpg', 'jpeg', 'bmp'],
            sizeMessage: 'Maximum file allowed size is 5MB',
            typeMessage: 'File formats allowed are jpeg, jpg, png, bmp'
        },
        1: {
            size: 5242880,
            types: ['jpeg', 'jpg', 'png', 'bmp'],
            sizeMessage: 'Maximum file allowed size is 5MB',
            typeMessage: 'File formats allowed are jpeg, jpg, png, bmp'
        },
        2: {
            size: 5242880,
            types: ['pdf', 'doc', 'docx', 'txt'],
            sizeMessage: 'Maximum file allowed size is 5MB',
            typeMessage: 'File formats allowed are pdf, doc, docx, txt'
        },
        3: {
            size: 5242880,
            types: ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'png'],
            sizeMessage: 'Maximum file allowed size is 5MB',
            typeMessage: 'File formats allowed are pdf, doc, docx, xls, xlsx, png'
        },
        4: {
            size: 5242880,
            types: ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'jpeg', 'jpg', 'png', 'bmp', 'zip', 'rar'],
            sizeMessage: 'Maximum file allowed size is 5MB',
            typeMessage: 'File formats allowed are pdf, doc, docx, xls, xlsx, jpeg, jpg, png, bmp, zip, rar'
        },
        5: {
            size: 5242880,
            types: ['xlsx'],
            sizeMessage: 'Maximum file allowed size is 5MB',
            typeMessage: 'File format allowed is xlsx '
        },
        6: {
            size: 5242880,
            types: ['pdf', 'doc', 'docx', 'txt', 'xls', 'xlsx', 'jpeg', 'jpg', 'png', 'bmp'],
            sizeMessage: 'Maximum file allowed size is 5MB',
            typeMessage: 'File formats allowed are pdf, doc, docx, txt, xls, xlsx, jpeg, jpg, png, bmp'
        },
        7: {
            size: 5242880,
            types: ['pdf', 'doc', 'docx', 'jpeg', 'jpg', 'png', 'bmp'],
            sizeMessage: 'Maximum file allowed size is 5MB',
            typeMessage: 'File formats allowed are pdf, doc, docx, jpeg, jpg, png, bmp '
        },
        8: {
            size: 5242880,
            types: ['pdf'],
            sizeMessage: 'Maximum file allowed size is 5MB',
            typeMessage: 'Only PDF files allowed'
        },
        9: {
            size: 5242880,
            types: ['doc', 'docx', 'xls', 'xlsx', 'jpeg', 'jpg', 'png', 'bmp'],
            sizeMessage: 'Maximum file allowed size is 5MB',
            typeMessage: 'File formats allowed are doc, docx, xls, xlsx, jpeg, jpg, png, bmp '
        },
        10: {
            size: 5242880,
            types: ['pdf', 'doc', 'docx', 'xls', 'xlsx'],
            sizeMessage: 'Maximum file allowed size is 5MB',
            typeMessage: 'File formats allowed are pdf, doc, docx, xls, xlsx '
        },
        11: {
            size: 5242880,
            types: ['xls', 'xlsx'],
            sizeMessage: 'Maximum file allowed size is 5MB',
            typeMessage: 'File formats allowed are xls, xlsx'
        },
        12: {
            size: 5242880,
            types: ['doc', 'docx'],
            sizeMessage: 'Maximum file allowed size is 5MB',
            typeMessage: 'File formats allowed are doc, docx'
        },
        13: {
            size: 5242880,
            types: ['doc', 'docx', 'txt', 'rtf', 'pdf', 'html', 'htm'],
            sizeMessage: 'Maximum file allowed size is 5MB',
            typeMessage: 'File formats allowed are doc, docx, txt, rtf, pdf, html, htm'
        },

        14: {
            size: 5242880,
            types: ['doc', 'docx', 'pdf', 'jpeg', 'jpg', 'png', 'bmp', 'rar', 'zip'],
            sizeMessage: 'Maximum file allowed size is 5MB',
            typeMessage: 'File formats allowed  are doc, docx, pdf, jpeg, jpg, png, bmp, rar, zip'
        },
        15: {
            size: 20971520,
            types: ['zip', 'rar'],
            sizeMessage: 'Maximum file allowed size is 20MB',
            typeMessage: 'File formats allowed are zip, rar'
        },
        16: {
            size: 20971520,
            types: ['pem', 'cert'],
            sizeMessage: 'Maximum file allowed size is 20MB',
            typeMessage: 'File formats allowed  pem , cert'
        },
        17: {
            size: 10485760,
            types: ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'jpeg', 'jpg', 'png', 'bmp', 'zip', 'rar'],
            sizeMessage: 'Maximum file allowed size is 10MB',
            typeMessage: 'File formats allowed are pdf, doc, docx, xls, xlsx, jpeg, jpg, png, bmp, zip, rar'
        }
    };

    private readonly _shared = inject(SharedService);
    constructor(
        private readonly _httpService: HttpService,
        public _snackBar: SnackbarAlertService
    ) { }

    getFileValidation(file, key) {
        const fileSize = this.fileValidation[key].size;
        const fileTypes = this.fileValidation[key].types;

        // check extention
        const ext = this.getFileExtention(file.name).toLowerCase();
        if (fileTypes.indexOf(ext) < 0) {
            this._snackBar.Alert(this.fileValidation[key].typeMessage, '3');
            return false;
        }
        // end ext

        // size validation
        if (file.size > fileSize) {
            this._snackBar.Alert(this.fileValidation[key].sizeMessage, '3');
            return false;
        }
        // end size

        return true;

    }

    getFileTypeValidation(file, key) {
        const fileTypes = this.fileValidation[key].types;

        // check extention
        const ext = this.getFileExtention(file.name).toLowerCase();
        if (fileTypes.indexOf(ext) < 0) {
            this._snackBar.Alert(this.fileValidation[key].typeMessage, '3');
            return false;
        }
        // end ext

        return true;

    }

    getFileExtention(name) {
        try {
            if (name) {
                return name.split('.').pop().toLowerCase();
            }
        } catch (err) {

        }

        return name;
    }

    uploadFileWithFolderId(
        payload: FileUploadWithFolderIdPayload,
        ignoreSize = false,
        uploadForEmployeeCode: string | null = null
    ): Observable<FileUploadWithFolderIdResponse> {
        const flag = ignoreSize
            ? this.getFileTypeValidation(payload.File, payload.FileExtensionsAllow)
            : this.getFileValidation(payload.File, payload.FileExtensionsAllow);
        if (!flag) return throwError(() => new Error('Invalid file type or size'));
        const formData = new FormData();
        formData.append('File', payload.File);
        formData.append('FolderId', payload.FolderId.toString());
        formData.append('EmployeeCode', uploadForEmployeeCode);
        return this._httpService.PostFileUpload(fileUrls.fileUploadUrl, formData);
    }

    uploadExternalFile(payload: UploadFileModel, appId, domainCode, ignoreSize?, isNewFlow = false): Promise<any> {
        return new Promise((resolve, reject) => {
            const fileExtensionKey = payload.FileExtensionsAllow ? payload.FileExtensionsAllow : 0;
            let flag;
            if (ignoreSize) {
                flag = this.getFileTypeValidation(payload.File, fileExtensionKey);
            } else {
                flag = this.getFileValidation(payload.File, fileExtensionKey);
            }

            if (flag) {
                const formData = new FormData();
                formData.append('File', payload.File);
                formData.append('FolderName', payload.FolderName);
                let url = fileUrls.imageResizeUpload;
                if (payload.apiType === 'file') {
                    url = '/api/external/access/File/Upload';
                    formData.append('FileExtensionsAllow', String(payload.FileExtensionsAllow));
                } else if (payload.apiType === 'userFile') {
                    url = '/api/external/access/UploadUserFile';
                    formData.append('FileExtensionsAllow', String(payload.FileExtensionsAllow));
                    formData.append('ModuleName', payload.ModuleName ? payload.ModuleName : '');
                    formData.append('ProcessName', payload.ProcessName ? payload.ProcessName : '');
                    formData.append('EmployeeCode', payload.EmployeeCode ? payload.EmployeeCode : '');
                } else if (payload.apiType === 'image') {
                    url = '/api/external/access/File/Upload';
                    formData.append('FileExtensionsAllow', String(1));
                    formData.append('IsResize', String(payload.isResize));
                }
                const postExternalFileMethod: 'PostExternalFile' | 'oldPostExternalFile' = (isNewFlow && this._shared.callNewFlow) ? 'PostExternalFile': 'oldPostExternalFile';

                this._httpService[postExternalFileMethod](url, appId, domainCode, formData)
                    .subscribe(
                        (response) => {
                            resolve(response);
                        },
                        () => {
                            reject(new Error("Whoops server error!"));
                        });
            } else {
                reject(new Error("Whoops client error!"));
            }
        });
    }

    getFileVirtualPath(fileDbName, externalCondition?: { 'external': boolean, 'appId': string, 'domainCode': string }, isNewFlow = false): Promise<string> {
        return new Promise((resolve, reject) => {
            if (fileDbName) {
                const query = encodeURIComponent(fileDbName);
                if (externalCondition?.external) {
                    this.useExternalUrl(query, resolve, reject, externalCondition, isNewFlow);
                }
            } else {
                reject(new Error("Whoops client error!"));
            }
        });
    }

    private useExternalUrl(query: string, resolve: (value: string | PromiseLike<string>) => void, reject: (reason?: any) => void, externalCondition: { 'external': boolean, 'appId': string, 'domainCode': string }, isNewFlow = false) {
        let url = fileUrls.externalfileVirtualUrl + query + "&requestSource=null";
        if(this._shared.callNewFlow && !isNewFlow){
            url  =  url.replace('/external','/external/public')
        }
        // callNewFlow true → new method; false → old method (url without /public)
        const request$ = this._shared.callNewFlow
            ? this._httpService.GetUnauthorizedWithAppId(url, externalCondition.appId, externalCondition.domainCode)
            : this._httpService.oldGetUnauthorizedWithAppId(url, externalCondition.appId, externalCondition.domainCode);
        request$.subscribe((resp: TFileDownloadVirtualUrl) => {
            if (resp && resp.fileVirtualPath) {
                resolve(resp.fileVirtualPath);
            } else {
                reject(new Error("Whoops server error!"));
            }
        }, err => {
            reject(new Error("Whoops client error!"));
        })
    }

    isImage(fileName) {
        const ext = this.getFileExtention(fileName);
        const list = this.fileValidation['0'].types;
        if (list.indexOf(ext) >= 0) {
            return true;
        } else {
            return false;
        }
    }

    isFileViewable(fileName) {
        const ext = this.getFileExtention(fileName);
        const list = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'txt'];
        if (list.indexOf(ext) >= 0) {
            return true;
        } else {
            return false;
        }
    }

    downloadFile(path) {
        if (path) {
            fetch(path).then((response) => {
                return response.blob()
            }).then(blob => {
                const blobURL = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = blobURL;
                const index = path.indexOf('?');
                const arr = path.slice(0, index).split('/');
                a.download = arr[arr.length - 1];
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                URL.revokeObjectURL(blobURL);
            });
        }
    }
}